import { writable } from "svelte/store";

export let intervalDuration = writable(300000);

export const activateGhosts = writable(false);

setTimeout(() => {
  activateGhosts.set(true);
}, 200);

export const resultData = writable([]);
export const seatData = writable([]);
export const coalitionOptions = writable([]);
export const candidates = writable([]);
export const timestamp = writable("");
export const newestSource = writable(0);
export const currentSource = writable(0);

export async function fetchSeats(result) {
  try {
    const baseURL = import.meta.env.VITE_APP_DATA_URL;

    const response = await fetch(baseURL);
    if (!response.ok) throw new Error("Fehler beim Abrufen der Sitzverteilung");
    const data = await response.json();
    const processedResults = data.results;
    const newestData =
      processedResults.length > 0
        ? processedResults.reduce((latest, current) => {
            return new Date(current.status_date) > new Date(latest.status_date) ? current : latest;
          })
        : null;
    resultData.set(processedResults);
    candidates.set(data.candidates);
    timestamp.set(data.timestamp);
    newestSource.set(processedResults.indexOf(newestData));
  } catch (error) {
    console.error("Fehler beim Laden der Sitzverteilung:", error);
  }
}
